import { Injectable } from '@angular/core';
import {ExamsService} from './exams.service';
import  *  as  dlist  from "../assets/tables/diagnosiscodes.json";
import * as cardiolist from "../assets/tables/cardio_diagnoses.json";
import  *  as  fetalEchodlist  from "../assets/tables/fetalEchoDiagnosis.json";
import  *  as  fetalEchoIndicationlist  from "../assets/tables/fetalechoIndecation.json";
import {LoginService} from './login.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class DiagnosisService {

  diagnosis_list;
  fetalEchoForm!:UntypedFormGroup;
  isFetal;
  isCardio=false;
  inSummary;
  inAnatomy;
  constructor(private es: ExamsService, private ls: LoginService, private fb:UntypedFormBuilder) {
    if(this.es.ExamType ==='Fetal Echo'){
      this.diagnosis_list=fetalEchodlist["default"];
    }else{
      this.diagnosis_list=dlist["default"];
    }
    this.fetalEchoForm = this.fb.group({
      FetaDiagnosisCodes: new UntypedFormControl(''),
      FetalAnomalies: new UntypedFormControl(''),
    })
   }

   getList(code: number){
     let list= [];
     for(let i =0; this.diagnosis_list && i < this.diagnosis_list.length; i++){
       if(this.diagnosis_list[i][3] == code)
        list.push(this.diagnosis_list[i]);
     }
     return list;
   }


   getTitle(insummary = false):string{
    if(this.ls.isCardio || this.isCardio)
      return 'Findings';
     if(this.ls.summaryOnlyAnamolies || insummary)
      return "Diagnosis";
    return 'Anomailes';
   }

   getItems(items:number[]){
     if(this.isFetal){
       if(this.inSummary){
        this.diagnosis_list=fetalEchodlist["default"]
       }else{
         this.diagnosis_list=fetalEchoIndicationlist["default"]
       }
     }else{
      if(this.ls.isCardio || this.isCardio)
        this.diagnosis_list = cardiolist['default'];
      else
        this.diagnosis_list=dlist["default"]
     }
    let list=[];
    for(let item of items){
      list.push(this.diagnosis_list[item -1]);
    }
    return list;
   }

   getName(id:number):string{
    //  if(!this.inSummary && this.isFetal){
    //    return this.diagnosis_list[id-2][2]
    //  }
     if(id < this.diagnosis_list.length)
      return this.diagnosis_list[id-1][2];
    return "";
   }

   save(diagnoses, table:string){
    if(this.es.isClosed)
      return;
    //make list
    let list = "";
    for(let d of diagnoses){
      list += d[0] + ",";
    }
    list = list.substr(0,list.length -1);
    if(this.isFetal && ! this.inSummary){
      this.es.saveVals('IndicationCodes',list,false,table);
    }else{
      this.es.saveVals('DiagnosisCodes',list,false,table);
    }
   }

   BuildList(values:string, insummary = false){
    if(! values || values ==  "")
      return [];
    let list=[]; 
    let ids = values.split(',');
    let name="";
    if(this.es.ExamType === 'Fetal Echo'){
      if(insummary){
        this.diagnosis_list = fetalEchodlist["default"]
      }else{
        this.diagnosis_list = fetalEchoIndicationlist["default"]
      }
    }else{
      if(this.ls.isCardio || this.isCardio)
        this.diagnosis_list = cardiolist['default'];
      else
        this.diagnosis_list=dlist["default"]
    }
    for(let id of ids){
      name = this.diagnosis_list[+id -1][2];
      name = this.diagnosis_list[this.diagnosis_list[+id -1][3] -1][2] + ' > '+ name;
      if(this.diagnosis_list[this.diagnosis_list[+id -1][3] -1][3] != 0)
        name =  this.diagnosis_list[this.diagnosis_list[this.diagnosis_list[+id -1][3] -1][3]-1][2] + ' > ' + name;
      list.push([id,name]);
    }
    return list;
   }

   getGroup(group:string){
    let items:number[]=[];
    switch(group){
      case 'cns':
        items= [18,161];
        break;
      case 'face':
        items= [113,222];
        break;
      case 'chest':
        items= [170,286];
        break;
      case 'digest':
        items = [1,141];
        break;
      case 'urology':
        items = [137,191];
        break;
      case 'skeleton':
        items=[42,233,244];
        break;
      case 'fetal':
        items=[1,25,31];
        break;
      case 'summary':
        if(this.ls.isCardio || this.isCardio){
          items = [1,7,27,38,77,83,92,100,110,120,130];
          break;
        }
        if(this.es.ExamType != 'Gynecology'){
          items = [315,321];
          if(this.ls.summaryOnlyAnamolies)
            items = [315,321,18,161,113,222,170,286,1,141,137,191,42,233,244]
          if(this.es.ExamType ==='Fetal Echo'){
            items = [1,27,43,67,77,86,99,110,126,131,142,152,158,166,172,212,224,234,253,269]
          }
        }
        else
          items = [331];
        break;

      case 'uterus':
        items = [520,617,644,667];
        break;
      case 'adnexa':
        items = [468];
        break;
      case 'cardioFindings':
        items = [1,7,27,38,77,83,92,100,110,120,130]
    }
    return this.getItems(items);
  }



}
